<template>
<div class='hs-button-group'>
  <template v-for='(btn, i) in btns'>
    <component
      class='btn'
      v-if='btn.component'
      :is='btn.component'
      :key='i'
      v-bind='btn.props'
    ></component>
    <el-button
      class='btn'
      :key="`btn${i}`"
      v-else-if='btn.type==="button"'
      v-bind='btn.props'
      @click='btn.handler'
    > {{ btn.rawLabel || (btn.label ? t(btn.label) : '') }}</el-button>
    <el-upload
      class='btn'
      :key="`upload${i}`"
      v-else-if='btn.type==="upload"'
      v-bind='btn.props'
    >
      <el-button v-bind='btn.btnProps'> {{ btn.rawLabel || (btn.label ? t(btn.label) : '') }} </el-button>
    </el-upload>
  </template>
  <slot name='default'></slot>
</div>
</template>

<script>
import Locale from '../../mixins/locale'

export default {
  name: 'HsButtonGroup',
  mixins: [Locale],
  props: {
    btns: Array
  }
}
</script>

<style scoped lang='scss'>
.hs-button-group {
  margin-bottom: 10px; 
  text-align: right;
  .btn + .btn{
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
  }
}
</style>